var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paint_mode_button",class:{selected: _vm.menu_mode === _vm.CONST.MENU_MODE_CLIPPING},on:{"click":_vm.modeChange}},[_c('span',[_vm._v("家具にかかる製品を消す")])])}
var staticRenderFns = []

export { render, staticRenderFns }